import styled from 'styled-components';

import { mediaTopBarVisible } from '@xing-com/layout-tokens';
import { SkeletonBodyCopy, SkeletonProfileImage } from '@xing-com/skeleton';
import { spaceL, spaceM, spaceXL, spaceXS } from '@xing-com/tokens';

const RecommendationsSkeletonContainer = styled.div`
  margin-top: ${spaceL};
`;

const RecommendationsCardSkeletonProfileImage = styled(SkeletonProfileImage)`
  height: 100%;
  margin-bottom: ${spaceL};
  width: 100%;
`;

const RecommendationsCardSkeletonContainer = styled.div`
  padding: ${spaceL} ${spaceM} ${spaceXL};

  @media ${mediaTopBarVisible} {
    padding: ${spaceXS} ${spaceXS} ${spaceM};
  }
`;

const RecommendationsCardSkeletonBodyCopy = styled(SkeletonBodyCopy)`
  margin-bottom: ${spaceXL};
`;

export const Styled = {
  RecommendationsSkeletonContainer,
  RecommendationsCardSkeletonContainer,
  RecommendationsCardSkeletonProfileImage,
  RecommendationsCardSkeletonBodyCopy,
};
